import { useEffect } from 'react';
import { STORE_ORIGIN } from '../config';

export default function AdminRedirect() {
  useEffect(() => {
    const origin = STORE_ORIGIN || (process.env.NODE_ENV === 'development'
      ? `${window.location.protocol}//${window.location.hostname}:8000`
      : window.location.origin);
    window.location.replace(`${origin}/admin/login.php`);
  }, []);
  return null;
}
